import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ApiConfig } from './config/api.config';
import { Lista } from '../models/lista.model';

@Injectable()
export class DocumentTypeService{

    constructor(
        private http: HttpClient,
        private api: ApiConfig
    ){}

    getDocumentType(TypeOption : string) : Observable<Array<Lista>>{
        
        return this.http.get<Array<Lista>>(this.api.url + '/documenttype/' + TypeOption);
    }

}


// WEBPACK FOOTER //
// /app/src/app/shared/services/documenttype.service.ts